import { Pipe, PipeTransform } from '@angular/core';
import { Question } from "@bequeathed/ngx-services";

/**
 * Filters questions for the summary page if they are of HIDDEN type
 *
 * @author Dan Bennett (dbennett)
 */
@Pipe({
    name: 'filterTypes'
})
export class FilterTypesPipe implements PipeTransform {

    filterTypes = ['HIDDEN', 'NOTE']

    transform(value: Question[]): Question[] {
        return value.filter(q => this.filterTypes.findIndex(t => q.type === t) === -1);
    }

}
